// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { productPrimaryImageStyles } from "@stoneage/Overrides/Components/ProductPrimaryImage";
import { css } from "styled-components";
import IconZoom from "@stoneage/XDL/Icons/IconZoom";

productPrimaryImageStyles.centeringWrapper = {
    css: css`
        min-height: 288px;
        width: 100%;
        margin-bottom: 12px;
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
        &:hover {
            cursor: pointer;
        }
        img {
            height: auto;
            max-width: 100%;
        }

        @media print {
            min-height: 180px;
        }
    `,
};

productPrimaryImageStyles.zoomIcon = {
    src: IconZoom,
    size: 16,
    color: "secondary",
    css: css`
        position: absolute;
        bottom: 8px;
        right: 8px;

        @media print {
            display: none;
        }
    `,
};
